import AbstractComponent from './AbstractComponent';
import Modal from 'components/Modal';
import CartJS from 'shopify-cartjs';

class Cart extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleCartReady = this.handleCartReady.bind(this);
    this.handleCartRequestComplete = this.handleCartRequestComplete.bind(this);
    this.addCompareAtPrice = this.addCompareAtPrice.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$modal = ui.$element.querySelector('.modal--cart');
    return ui;
  }

  initializeBeforeEvents() {
    super.initializeBeforeEvents();

    const { $modal } = this.ui;
    if ($modal) {
      this.modal = new Modal({ $element: $modal });
    }
  }

  initialize() {
    if (window.COMBEAU_CART) {
      const { cart, moneyFormat, moneyWithCurrencyFormat } = window.COMBEAU_CART;

      CartJS.init(cart, {
        moneyFormat,
        moneyWithCurrencyFormat,
      });
    }
  }

  events(listen) {
    const listener = listen ? 'on' : 'off';
    $(document)[listener]('cart.ready', this.handleCartReady);
    $(document)[listener]('cart.requestComplete', this.handleCartRequestComplete);
  }

  handleCartReady(event, cart) {
    this.addCompareAtPrice(cart);
  }

  handleCartRequestComplete(event, cart) {
    this.addCompareAtPrice(cart);
    this.modal.open();
  }

  addCompareAtPrice(cart) {
    cart.items.map((item) => {
      const url = `/products/${item.handle}.json`;
      $.get(url, ({ product }) => {
        product.variants.map(({ id, compare_at_price }) => {
          if (id === item.variant_id) {
            item.compare_at_price = parseInt(100 * compare_at_price);
            cart.items.forEach(
              (item) => (item.line_compare_at_price = item.compare_at_price * item.quantity)
            );
          }
        });
      });
    });
  }
}

export default Cart;
